import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from 'store/store'

import { useLazyGetProductAccessoriesQuery } from '@/entities/product'

import { getOrderUrl } from '../lib/get-order-url'

import { AccessoriesOfferAction, openAccessoriesOffer, OpenAccessoriesOfferPayload } from './accessories-offer-slice'

const EXCLUDED_SECTION_NAME = 'Сервисы и страхование'

export const useOpenAccessoriesOffer = () => {
	const dispatch = useDispatch()
	const router = useRouter()
	const isEnabled = useAppSelector(state => state.accessoriesOffer.isEnabled)
	const [getAccessories] = useLazyGetProductAccessoriesQuery()
	const [loadingAction, setLoadingAction] = useState<AccessoriesOfferAction>()

	const open = async (payload: OpenAccessoriesOfferPayload, waitFor?: Promise<unknown>) => {
		if (!isEnabled) return false

		setLoadingAction(payload.action)

		try {
			const [accessories] = await Promise.all([getAccessories(payload.productId).unwrap(), waitFor])

			const hasAccessories = Object.values(accessories ?? {}).some(
				group => group.SECTION_NAME !== EXCLUDED_SECTION_NAME && group.ACCESSORIES?.length
			)

			if (!hasAccessories) return false

			dispatch(openAccessoriesOffer(payload))
			return true
		} catch {
			return false
		} finally {
			setLoadingAction(undefined)
		}
	}

	const openOrder = async (payload: OpenAccessoriesOfferPayload & { action: 'fast' | 'preorder' }) => {
		const isOfferOpened = await open(payload)

		if (!isOfferOpened) await router.push(getOrderUrl([payload.productId], payload.productCode, payload.orderQuery))
	}

	return { loadingAction, openAccessoriesOffer: open, openOrderWithAccessories: openOrder }
}
